var _rect, _g, _g2, _g3, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 360,
    preserveAspectRatio: "none",
    viewBox: "0 0 356 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 346,
    transform: "translate(6 8)",
    fill: "url(#paint0_linear_825_2366)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_2366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.139 8L252.994 4.65437e-07L97.2913 1.40774e-05L91 8.00001L260.139 8Z",
    fill: "#C71A33"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_825_2366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 10L126.647 16L227.908 16L232 10L122 10Z",
    fill: "#C71A33"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_825_2366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 8L58.9137 11L294.511 11L305 8.00005L47 8Z",
    fill: "#C71A33"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 339.5V354.5H21",
    stroke: "#C71A33",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 339.5V354.5H335",
    stroke: "#C71A33",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.5V7.5H21",
    stroke: "#C71A33",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350 22.5V7.5H335",
    stroke: "#C71A33",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_825_2366",
    x1: 29.2578,
    y1: 28.5826,
    x2: 443.553,
    y2: 477.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282929",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_2366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169.139,
    height: 8,
    fill: "white",
    transform: "translate(260.139 8) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_825_2366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 5.99998,
    fill: "white",
    transform: "translate(122 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_825_2366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 7.99995,
    fill: "white",
    transform: "translate(47 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFrame);
export default __webpack_public_path__ + "static/media/card-frame.854163b75eecb173120eedaa0770c4fc.svg";
export { ForwardRef as ReactComponent };